import styled from "styled-components";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";

export const DropdownHeader = styled.div`
    padding: ${({ theme }) => `${theme.spacing[8]} ${theme.spacing[16]}`};
`;

export const ProductContainer = styled(Flex)`
    padding: ${({ theme }) => theme.spacing[16]};
    cursor: pointer;

    :hover {
        background-color: ${({ theme }) => theme.grayscale[10]};
    }
`;

export const ProductLogoContainer = styled(Flex)<{ backgroundColor: string }>`
    padding: ${({ theme }) => `${theme.spacing[4]} ${theme.spacing[8]}`};
    border-radius: ${({ theme }) => theme.radius.s};
    width: ${({ theme }) => theme.rem(2.5)};
    height: ${({ theme }) => theme.rem(2.5)};
    background-color: ${({ backgroundColor }) => backgroundColor};
`;
